import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import { BrowserRouter, Route, Routes, useSearchParams } from 'react-router-dom';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import BreadcrumbsNavigator, { BreadcrumbsNavigatorProps } from '@/components/shared/Breadcrumbs/BreadcrumbsNavigator';
import GradingHooks from './GradingHooks';
import CardContainer from './CardContainer';
import HeaderWithFilters from './HeaderWithFilters';

interface GradingProps {
  breadcrumbsData: BreadcrumbsNavigatorProps
  programId: number;
  studentViewAssessmentResults?: boolean;
  userId: number;
  userType: string;
}

const Grading = ({ breadcrumbsData, programId, studentViewAssessmentResults, userId, userType } : GradingProps) => {
  GradingHooks({ programId, studentViewAssessmentResults, userId, userType });
  const { isLoading, assignment, showAnswers } = useGradingStore();
  const [searchParams] = useSearchParams();

  const renderBreadcrumbsNav = () => (
    <BreadcrumbsNavigator
      page="grades"
      searchParams={searchParams}
      {...breadcrumbsData}
    />
  );

  if (isLoading) {
    return (
      <>
        {renderBreadcrumbsNav()}
        <span>Loading...</span>
      </>
    );
  }

  return (
    <>
      {renderBreadcrumbsNav()}
      <div className="tw-py-4">
        <h1>{assignment.assignment_details.type} Results by Student</h1>
      </div>
      <HeaderWithFilters />
      {showAnswers() ? (
        <CardContainer />
      ) : (
        <div className="tw-text-center tw-text-base tw-m-5">
          Your teacher has disabled viewing answers to assessment questions.
        </div>
      )}
    </>
  );
};

const GradingWrapper = ({
  breadcrumbsData, programId, studentViewAssessmentResults, userId, userType,
} : GradingProps) => (
  <ReactQueryProvider>
    <BrowserRouter basename="/teacher/submissions">
      <Routes>
        <Route
          element={(
            <Grading
              breadcrumbsData={breadcrumbsData}
              programId={programId}
              studentViewAssessmentResults={studentViewAssessmentResults}
              userId={userId}
              userType={userType}
            />
          )}
          path=":submissionId"
        />
      </Routes>
    </BrowserRouter>
  </ReactQueryProvider>
);

export default GradingWrapper;
